export default __webpack_public_path__ + "static/media/36I-102699_-15670_0.fc4cfa65.jpg";